import { combineReducers } from 'redux';
import menuReducer from './menu.reducer';
import { userAuthentication } from './user.reducers';

const rootReducer = combineReducers({
  userAuthentication,
  menuReducer
});

export default rootReducer;
